import { canUsePassiveEventListeners } from './supports-passive';
export function normalizeEventOptions(eventOptions) {
    if (!eventOptions) {
        return false;
    }
    if (!canUsePassiveEventListeners()) {
        return !!eventOptions.capture;
    }
    return eventOptions;
}
